import {useLocation} from "react-router-dom";
import {useUserSettings} from "../store/userSettings/reducer";
import {useLocalStorage} from "@rehooks/local-storage";
import {LocalStorageKeys} from "../common/types";
import {UsersSettingsAPI} from "../services/UsersSettingsAPI";

type BadgeStorage = Record<string, boolean>;

export const useBadgeDismiss = () => {
    const userSettings = useUserSettings();
    const api = new UsersSettingsAPI();
    const location = useLocation();
    const labelInitStatus = userSettings.labelNew;

    let [badges, setBadges] = useLocalStorage<BadgeStorage>(LocalStorageKeys.BadgesDismiss, labelInitStatus);

    if (badges === null) {
        badges = labelInitStatus;
    }

    const isShowBadge = (url: string) => {
        if (!badges!.hasOwnProperty(url)) {
            return false;
        }

        if (badges!.hasOwnProperty(url) && !badges![url]) {
            return false;
        }

        return true;
    };

    const markAsVisited = (url: string) => {
        if (location.pathname.substring(1) === url) {
            const currentValue = badges![url] ?? null;
            if (currentValue) {
                badges![url] = false;
                setBadges(badges!);

                api.markBadge(url).catch((_) => {});
            }
        }
    }

    return {
        badges,
        setBadges,
        labelInitStatus,
        isShowBadge,
        markAsVisited
    };
};
